"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenLessonPayloadSchema = void 0;
exports.GenLessonPayloadParse = GenLessonPayloadParse;
const zod_1 = require("zod");
exports.GenLessonPayloadSchema = zod_1.z.object({
  data: zod_1.z.string().trim().min(16, `data_invalid`).max(256, `data_invalid`)
});
function GenLessonPayloadParse(dto) {
  return exports.GenLessonPayloadSchema.parse(dto);
}
